module.exports = __webpack_public_path__ + "static/barbary_coast_logo-5b6e58cf8347cced22e4eb6a71714fdd.png";